module.exports = __webpack_public_path__ + "img/full2-min.23f98600.png";